import get from 'lodash/get';

export const getSelectedPeople = state => get( state, 'people.selectedPeople', [] );
export const getSearchedPeople = state => get( state, 'people.searchedPeople', [] );
export const getMyTeam = state => get( state, 'people.myTeam', [] );
